import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { viewDocument } from 'src/app/controls/functions/functions';
import { ConfirmationComponent } from 'src/app/modules/shared/confirmation/confirmation.component';
import { NotificationService } from 'src/app/services/shared/notification/notification.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-language-list',
  templateUrl: './language-list.component.html',
  styleUrls: ['./language-list.component.scss']
})
export class LanguageListComponent implements OnInit {

  certifiedTypeList = [];
  scoreMasterList = []
  masters: any = {};
  language_list = []
  languageForm: UntypedFormGroup = new UntypedFormGroup({
    languageId: new UntypedFormControl(null, Validators.required),    // all master -> sharedMasterData.lngMasterList
    speakId: new UntypedFormControl(null),// sharedMasterData.srwMasterList
    readId: new UntypedFormControl(null),// sharedMasterData.srwMasterList
    writeId: new UntypedFormControl(null),// sharedMasterData.srwMasterList
    certifiedId: new UntypedFormControl(null),//sharedMasterData.certifiedTypeList (Local filter this list based on 	language selection)
    score: new UntypedFormControl(null),// sharedMasterData.scoreMasterList (local filter this based on certifiedId selection)
    attachment: new UntypedFormControl(null),
  })
  constructor(
    private dialog_ref: MatDialogRef<LanguageListComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private dialog: MatDialog,
    private notification: NotificationService
  ) { }

  ngOnInit(): void {
    if (this.data) {
      if (this.data.languageData && this.data.languageData.length) {
        this.language_list = this.data.languageData
      }
      this.masters = this.data.masters;
      // if (this.masters) {
      //   this.certifiedTypeList = [...this.masters.certifiedTypeList]
      //   this.scoreMasterList = [...this.masters.scoreMasterList]
      // }
    }
  }

  close() {
    this.dialog_ref.close(this.language_list)
  }
  save() {
    this.dialog_ref.close(this.language_list)
  }
  languageChanged(ev) {
    console.log(ev)
    if (ev && ev.id) {
      this.languageForm.controls.certifiedId.reset();
      this.languageForm.controls.certifiedId.updateValueAndValidity()
      this.scoreMasterList = [];
      if (this.masters.certifiedTypeList && this.masters.certifiedTypeList.length) {
        this.certifiedTypeList = this.masters.certifiedTypeList.filter(data => data.languageId == ev.id)
      }
    }
  }
  certifiedChanged(ev) {
    if (ev && ev.id) {
      this.languageForm.controls.score.reset();
      this.languageForm.controls.score.updateValueAndValidity()
      if (this.masters.scoreMasterList && this.masters.scoreMasterList.length) {
        this.scoreMasterList = this.masters.scoreMasterList.filter(data => data.certifiedId == ev.id)
      }
    }
  }

  addLanguage() {
    if (this.languageForm.valid) {
      this.language_list.push(this.languageForm.value)
      this.languageForm.reset()
    }
    else {
      this.notification.error('Please fill mandatory fields to proceed', 'Close', 5000)
    }
  }
  editEducation(item, index) {
    this.languageForm.reset();
    this.languageForm.patchValue(item);
    this.language_list.splice(index, 1)
  }
  deleteEducation(index) {
    this.dialog.open(ConfirmationComponent, {
      width: '30%',
      height: 'auto',
      data: {
        title: 'CONFIRMATION.confirmation',
        message: 'CONFIRMATION.are_you_sure_to_delete',
      }
    }).afterClosed().subscribe(res => {
      if (res) {
        this.language_list.splice(index, 1)
      }
    })
  }
  viewAttachments(attachments) {
    if (attachments && attachments.length) {
      viewDocument(attachments, attachments[0], this.dialog)
    }
  }

}

